import { SearchableRecordInstantSearch } from '@livv/models';
import { Hit, HitAttributeSnippetResult, HitSnippetResult } from 'instantsearch.js';

const isAttributeSnippeted = (
    hitAttribute:
        | HitAttributeSnippetResult[]
        | HitSnippetResult[]
        | HitAttributeSnippetResult
        | HitSnippetResult,
): boolean => {
    if (Array.isArray(hitAttribute)) {
        return hitAttribute.some((value) => {
            // asserting that we need to go deeper into the object to find the matchLevel key
            if (!Object.keys(value).includes('matchLevel')) {
                return Object.values(value).some((nestedValue) =>
                    isAttributeSnippeted(nestedValue),
                );
            }

            return value?.matchLevel !== 'none';
        });
    }

    return hitAttribute?.matchLevel !== 'none';
};

export const getSnippetedAttributes = (hit?: Hit<SearchableRecordInstantSearch>): string[] => {
    // eslint-disable-next-line no-underscore-dangle
    if (!hit?._snippetResult) {
        return [];
    }

    // eslint-disable-next-line no-underscore-dangle
    return Object.keys(hit._snippetResult).filter((key) => {
        // eslint-disable-next-line no-underscore-dangle
        if (!hit._snippetResult) {
            return false;
        }

        // eslint-disable-next-line no-underscore-dangle
        return isAttributeSnippeted(hit._snippetResult[key]);
    });
};

export const getFullTextSearchQuery = (
    hit: Hit<SearchableRecordInstantSearch>,
    query?: string,
): string | undefined =>
    query && getSnippetedAttributes(hit).includes('fullText') ? query : undefined;

interface HitWithAnalysisSnippets {
    _snippetResult?: {
        analyses?: {
            fullText?: HitAttributeSnippetResult;
        }[];
    };
}

export const hasAnalysisFullTextMatch = (hit: HitWithAnalysisSnippets, index: number): boolean => {
    // eslint-disable-next-line no-underscore-dangle
    const matchLevel = hit._snippetResult?.analyses?.[index]?.fullText?.matchLevel;

    return matchLevel !== undefined && matchLevel !== 'none';
};
